module.exports = __webpack_public_path__ + "img/38.1b196450.png";